import React from "react";
import DocumentList from "../pages/DocumentList";

const DocumentsTable = () => {
  // Pass any necessary props or context here if needed for filtering by case file
  return <DocumentList context="case" hideUploadButton={true} addbutton={true} />;
};

export default DocumentsTable;
